import axios from "../../config/axiosConfig";
import {
  GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST,
  GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS,
  GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE,
  GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_REQUEST,
  GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_SUCCESS,
  GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE
} from "../types/general-purchase-outstanding-report-types";

export const getGeneralPurchaseOutstandingRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/outstanding-report/getGeneralPurchaseReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get('/outstanding-report/getGeneralPurchaseReport', {
        params: requestParams,
      }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Outstanding Report:", error);
        dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Outstanding Report:", error);
      dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getGeneralPurchaseOutstandingRegisterReportFilterDetail = (isCommonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_REQUEST });
            const { auth } = getState();
            let defaultParams = {};
            if (isCommonMaster) {
                defaultParams = {
                    // companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            } else {
                defaultParams = {
                    companyId: auth.company?.id,
                    customerId: auth.user?.Customer_Id,
                };
            }
            // const defaultParams = {
            //     companyId: auth.company?.id,
            //     customerId: auth.user?.Customer_Id,
            // };
            const requestParams = { ...defaultParams };
            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/outstanding-report/getGeneralPurchaseReportFilters?${queryString}`;
            console.log('<<Complete API Request URL: ', fullUrl);
            return axios.get(fullUrl).then((response) => {
                console.log('API Response Data: ', response);
                if (response.data) {
                dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching general purchase outstanding Report Filters:", error);
                dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching general purchase outstanding Report Filters:", error);
            dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearGeneralPurchaseOutstandingRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: GENERAL_PURCHASE_OUTSTANDING_REPORT_SUCCESS, payload: {} });
  }
}